import Permissions, { usePermissions } from '@app/src/auth/permissions'
import type { NavigationItemProps } from '@app/src/components/Navigation/VerticalMenu/NavigationItems/NavigationItems'
import navigationLinks from '@app/src/wf-constants/navigationLinks'
import React from 'react'
import { useIntl } from 'react-intl'
import type { MenuWrapperProps } from './MenuWrapper'
import MenuWrapper from './MenuWrapper'

const TransparencyProductMenu: React.FC<NavigationItemProps> = ({ icon }) => {
  const { formatMessage } = useIntl()
  const { hasPermission } = usePermissions()

  if (!hasPermission(Permissions.PRODUCT_MAPPING_RESPOND_ACCESS)) return null

  const menuItems: MenuWrapperProps['menuItems'] = [
    {
      title: formatMessage({ id: 'navbar.receivedMappingRequests' }),
      link: navigationLinks.mappingRequests,
      permission: [Permissions.TRANSPARENCY_USER],
    },
    {
      title: formatMessage({ id: 'navbar.companies' }),
      link: navigationLinks.productMappingCompanies,
      permission: [Permissions.TRANSPARENCY_USER],
    },
    {
      title: formatMessage({ id: 'navbar.contacts' }),
      link: navigationLinks.productMappingContacts,
    },
    {
      title: formatMessage({ id: 'navbar.allProducts' }),
      link: navigationLinks.products,
      permission: [Permissions.TRANSPARENCY_USER],
    },
  ]

  return <MenuWrapper icon={icon} menuItems={menuItems} title={formatMessage({ id: 'navbar.productMapping' })} />
}

export default TransparencyProductMenu
